import { render, staticRenderFns } from "./Berita.vue?vue&type=template&id=1da6d3d5&scoped=true&lang=html&"
import script from "./Berita.vue?vue&type=script&lang=js&"
export * from "./Berita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6d3d5",
  null
  
)

export default component.exports